import { ConferencePromo } from '@fs/zion-rootstech'

export const ListModule = `
  ${ConferencePromo}
  fragment ListModule on ListModule {
    ctaLabel
    ctaTarget
    ctaText
    ctaUrl
    description
    items {
      ...ConferencePromo
    }
    secondaryTitle
    title
    _style {
      _styleVariation {
        _styledTemplate
      }
    }
  }
`
